import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeAllCitiesList } from './normalize';

export const fetchAllCitiesList = createProvider(api.fetchAllCitiesList)
  .andThen((res) => normalizeAllCitiesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
